
import NoteSquare from "../../../assets/outline/NoteSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function NoteSquareIcon({ className, dataTestid = "NoteSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <NoteSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
